import { render } from "./error-message.vue?vue&type=template&id=68980320&scoped=true"
import script from "./error-message.vue?vue&type=script&lang=js"
export * from "./error-message.vue?vue&type=script&lang=js"

import "./error-message.vue?vue&type=style&index=0&id=68980320&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68980320"]])

export default __exports__